/* THE ONE FILE THAT LOADS THE CAPTURED COMPETITOR LIST.
 *
 * Same split as `assignments.js` over `assignmentModel.js`: the policy is pure
 * and takes its data, this binds the shipped JSON to it. Two consequences worth
 * stating, because both are the point rather than side effects:
 *
 *   1. `verify-cheer-incumbent.mjs` drives the REAL matcher under plain Node.
 *   2. Refreshing the capture — rerun `tools/gen-hj-cheer-tam.mjs` against a new
 *      `raw.txt` — sharpens every badge and every count with NO code change.
 *
 * The list is read at RUNTIME. Nothing here writes to HubSpot; an incumbent
 * claim sourced from a competitor's marketing page stays a read-layer overlay
 * until somebody deliberately decides otherwise.
 */

import HJ from '../data/hj_cheer_accounts.json'
import { buildIncumbentIndex, incumbentFor, incumbentRollup } from './cheerIncumbent.js'

export const HJ_INDEX = buildIncumbentIndex(HJ)
export const HJ_META = HJ.meta || {}
export const HJ_GYM_COUNT = HJ_INDEX.gyms.length

export const incumbent = (gym) => incumbentFor(gym, HJ_INDEX)
export const isHerffJones = (gym) => incumbent(gym).confidence === 'confirmed'
export const rollup = (gyms) => incumbentRollup(gyms, HJ_INDEX)

export { HERFF_JONES, PACKAGE_PRICE, hasRingPrice, tierMeta } from './cheerIncumbent.js'
